
<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="10px">
  <div class="flex-row gap-8 align-center">
    <span class="title">Banners</span>
    @if (editable) {
      <lib-button [disabled]="banners.length > 4" (buttonClick)="onAdd()" tooltip="Add new banner" icon="add" style="max-width: 140px;">Add banner</lib-button>
    }
  </div>

  <div fxLayout="row" fxLayoutGap="10px">
    @for (b of banners; track b) {
      <div class="banner">
        <app-campaign-banner-image [editable]="editable" [banner]="b" (bannerUploaded)="onBannerUploaded($event)"></app-campaign-banner-image>
        @if (editable) {
          <div class="banner-actions">
            <lib-button variant="icon" (click)="onRemove(b)" tooltip="Remove banner" icon="close"></lib-button>
          </div>
        }
      </div>
    }
  </div>

  @if (showBannerDuration) {
    <div>
      <span class="title">Settings</span>
      <div class="wid-200">
        <form [formGroup]="form" class="vertical-form" novalidate>
          <mat-form-field>
            <mat-label>Auto-slide duration (1 - 60 seconds)</mat-label>
            <input formControlName="bannerDuration" matInput type="number">
            @if (!form.get('bannerDuration').valid) {
              <mat-error>Please enter a valid duration</mat-error>
            }
          </mat-form-field>
        </form>
      </div>
    </div>
  }
</div>